import React, { Component } from "react";

export class AppStepper extends Component {
  constructor(props) {
    super(props);
    let { count = 0, index = 0 } = props;
    let stepList = [];
    stepList.length = count;
    stepList = stepList.fill("incomplete");
    if (index > 0) {
      stepList = stepList.map((val, i) => (i <= index - 1 ? "complete" : val));
    }
    this.state = {
      stepList,
    };
  }
  componentDidMount() {
    this.props.steps?.map((step, i) => {
      this.setState({ ...step });
    });
  }
  render() {
    let { count, index } = this.props;
    let { stepList = [] } = this.state;
    console.log(stepList, count);
    return (
      <div className="custom_stepper_container">
        <div className="custom_stepper">
          {stepList.map((step, i) => (
            <div
              key={i}
              className={Object.className({
                "custom_stepper-item": true,
                [step]: true,
              })}
            >
              <span className="custom_stepper_text " data-custom-stepper="0">
                Step {i + 1}
              </span>
              <div className="arrow"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default AppStepper;